module.exports = __webpack_public_path__ + "img/icon_go.8250ee8f.svg";